(function () {
    $(document).on('click', '.JScontextualizeCollectionsList a', function (e) {
        e.preventDefault();
        const target = this.hash,
            $target = $(target),
            position = $target.offset().top - '90';

        $('html, body').stop().animate(
            {
                scrollTop: position,
            },
            300
        );
    });
})();
